module.exports = __webpack_public_path__ + "static/img/mail.6501bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mail.png
// module id = 8ni1
// module chunks = 1